var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.6419V15.4858C1 15.6222 1.05417 15.753 1.15061 15.8494C1.24704 15.9458 1.37783 16 1.5142 16H3.35812C3.49423 16 3.62478 15.946 3.72114 15.8499L12.4625 7.10847L9.89153 4.53747L1.15015 13.2789C1.05402 13.3752 1.00003 13.5058 1 13.6419ZM11.8907 2.53826L14.4617 5.10926L15.6989 3.8721C15.8917 3.67924 16 3.41771 16 3.14502C16 2.87232 15.8917 2.6108 15.6989 2.41794L14.5821 1.3011C14.3892 1.10831 14.1277 1 13.855 1C13.5823 1 13.3208 1.10831 13.1279 1.3011L11.8907 2.53826Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a8edb96319076190a18c1585d7aeed6d.svg";
export { ForwardRef as ReactComponent };